export default "__VITE_ASSET__641b382f__"